import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'l-course-category-tag',
  standalone: true,
  templateUrl: './course-category-tag.component.html',
  imports: [TooltipModule],
})
export class CourseCategoryTagComponent {

  @Input({ required: true })
  public label = '';

  @Input()
  public backgroundColor = '#5B55FF';

  @Input()
  public textColor = '#1E2030';

}
